import { disableScroll } from "../functions/disable-scroll";
import { enableScroll } from "../functions/enable-scroll";

export default function certificateForm() {
  const wrapper = document.querySelector(".certificate-modal__wrapper");

  let closeModal = () => {
    wrapper.classList.remove("certificate-modal__wrapper--active");
    enableScroll();
  };

  wrapper.addEventListener("click", (e) => {
    if (!e.target.closest(".certificate-modal")) {
      closeModal();
    }
  });

  const certrtificatesForms = document.querySelectorAll(
    ".js-certificates-form"
  );
  if (certrtificatesForms.length) {
    certrtificatesForms.forEach((form) => {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        let formData = new FormData(form);
        fetch("/wp-admin/admin-ajax.php", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.success) {
              form.reset();

              wrapper.classList.add("certificate-modal__wrapper--active");
              if (!document.body.classList.contains("dis-scroll")) {
                disableScroll();
              }
            }
          });
      });
    });
  }
}
